import React, { useState } from 'react';

const COLORS = {
  bleu: '#1E3A5F', brun: '#7A4E2D', fond: '#F7F8FA', texte: '#1F2937',
  modules: { rdv:'#1E3A5F', chantier:'#7A4E2D', conge:'#6B7280', echeance:'#F97316' }
};

const TYPES = [
  { value:'rdv', label:'📅 Rendez-vous', color:'#1E3A5F' },
  { value:'chantier', label:'🔨 Chantier', color:'#7A4E2D' },
  { value:'conge', label:'🌴 Congé', color:'#6B7280' },
  { value:'echeance', label:'⏰ Échéance', color:'#F97316' },
];

const MOIS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
const JOURS = ['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'];

export default function Agenda({ evenements, clients, affaires, onCreer, onModifier, onSupprimer, onOuvrirAffaire }) {
  const [vue, setVue] = useState('mois');
  const [dateRef, setDateRef] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [modeEdition, setModeEdition] = useState(false); // false = création, true = modification
  const [form, setForm] = useState({});
  const [jourSelectionne, setJourSelectionne] = useState(null);
  const [evenementDetail, setEvenementDetail] = useState(null);

  const s = {
    container: { background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' },
    header: { background: COLORS.bleu, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    titre: { color: 'white', fontWeight: '700', fontSize: '18px', margin: 0 },
    btnNav: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '16px' },
    btnVue: (active) => ({ background: active ? 'white' : 'transparent', color: active ? COLORS.bleu : 'white', border: '1px solid white', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: active ? '700' : 'normal' }),
    btnAdd: { background: '#F97316', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' },
    grille: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0 },
    jourHeader: { background: '#F3F4F6', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '700', color: '#6B7280', borderBottom: '1px solid #E5E7EB' },
    jour: (estMois, estAujourdhui) => ({
      minHeight: '90px', padding: '6px', border: '1px solid #F3F4F6',
      background: estAujourdhui ? '#EFF6FF' : estMois ? 'white' : '#F9FAFB',
      cursor: 'pointer', verticalAlign: 'top'
    }),
    jourNum: (estAujourdhui) => ({
      fontSize: '13px', fontWeight: estAujourdhui ? '700' : 'normal',
      background: estAujourdhui ? COLORS.bleu : 'transparent',
      color: estAujourdhui ? 'white' : '#374151',
      borderRadius: '50%', width: '24px', height: '24px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px'
    }),
    event: (color) => ({
      background: color, color: 'white', borderRadius: '4px',
      padding: '2px 6px', fontSize: '11px', marginBottom: '2px',
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer'
    }),
    input: { width: '100%', padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box' },
    label: { display: 'block', fontSize: '13px', color: '#374151', marginBottom: '4px', fontWeight: '600' },
    btn: (color) => ({ background: color, color: 'white', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', width: '100%' }),
  };

  const joursDuMois = () => {
    const annee = dateRef.getFullYear();
    const mois = dateRef.getMonth();
    const premier = new Date(annee, mois, 1);
    const dernier = new Date(annee, mois + 1, 0);
    const jourDebut = (premier.getDay() + 6) % 7;
    const jours = [];
    for (let i = 0; i < jourDebut; i++) {
      const d = new Date(annee, mois, -jourDebut + i + 1);
      jours.push({ date: d, estMois: false });
    }
    for (let i = 1; i <= dernier.getDate(); i++) {
      jours.push({ date: new Date(annee, mois, i), estMois: true });
    }
    while (jours.length % 7 !== 0) {
      const d = new Date(annee, mois + 1, jours.length - dernier.getDate() - jourDebut + 1);
      jours.push({ date: d, estMois: false });
    }
    return jours;
  };

  const joursDeLouvrier = () => {
    const lundi = new Date(dateRef);
    const jour = (lundi.getDay() + 6) % 7;
    lundi.setDate(lundi.getDate() - jour);
    return Array.from({length: 7}, (_, i) => {
      const d = new Date(lundi);
      d.setDate(lundi.getDate() + i);
      return d;
    });
  };

  const eventsJour = (date) => {
    return evenements.filter(e => {
      const d = new Date(e.date_debut);
      return d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear();
    });
  };

  const aujourdhui = new Date();
  const moisAnnee = `${MOIS[dateRef.getMonth()]} ${dateRef.getFullYear()}`;

  const precedent = () => {
    const d = new Date(dateRef);
    vue === 'mois' ? d.setMonth(d.getMonth() - 1) : d.setDate(d.getDate() - 7);
    setDateRef(d);
  };

  const suivant = () => {
    const d = new Date(dateRef);
    vue === 'mois' ? d.setMonth(d.getMonth() + 1) : d.setDate(d.getDate() + 7);
    setDateRef(d);
  };

  const payloadForm = (f, dateDebut) => ({
    titre: f.titre,
    description: f.description || null,
    date_debut: dateDebut,
    date_fin: f.date_fin || null,
    type: f.type || 'rdv',
    client_id: f.client_id ? parseInt(f.client_id) : null,
    affaire_id: f.affaire_id ? parseInt(f.affaire_id) : null,
    toute_la_journee: f.toute_la_journee || false
  });

  const validerModal = async () => {
    if (!form.titre || !form.date_debut) return alert('Titre et date sont obligatoires');
    const dateDebut = jourSelectionne && !modeEdition ? `${jourSelectionne}T${form.heure_debut||'09'}:00:00` : form.date_debut;
    if (modeEdition) {
      await onModifier(form.id, payloadForm(form, dateDebut));
    } else {
      await onCreer(payloadForm(form, dateDebut));
    }
    setShowModal(false); setModeEdition(false); setForm({}); setJourSelectionne(null);
  };

  const ouvrirModal = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    setJourSelectionne(dateStr);
    setModeEdition(false);
    setForm({ date_debut: dateStr + 'T09:00', type: 'rdv' });
    setShowModal(true);
  };

  const ouvrirEdition = (e) => {
    const debut = new Date(e.date_debut);
    const fin = e.date_fin ? new Date(e.date_fin) : null;
    const toLocal = (d) => new Date(d.getTime() - d.getTimezoneOffset()*60000).toISOString().slice(0,16);
    setForm({
      id: e.id, titre: e.titre, description: e.description||'',
      date_debut: toLocal(debut), date_fin: fin ? toLocal(fin) : '',
      type: e.type, client_id: e.client_id||'', affaire_id: e.affaire_id||''
    });
    setModeEdition(true);
    setEvenementDetail(null);
    setShowModal(true);
  };

  const jours = vue === 'mois' ? joursDuMois() : joursDeLouvrier().map(d => ({ date: d, estMois: true }));

  return (
    <div>
      <div style={s.container}>
        <div style={s.header}>
          <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
            <button style={s.btnNav} onClick={precedent}>‹</button>
            <h3 style={s.titre}>{moisAnnee}</h3>
            <button style={s.btnNav} onClick={suivant}>›</button>
            <button style={s.btnNav} onClick={() => setDateRef(new Date())} title="Aujourd'hui">●</button>
          </div>
          <div style={{display:'flex', gap:'8px', alignItems:'center'}}>
            <button style={s.btnVue(vue==='mois')} onClick={() => setVue('mois')}>Mois</button>
            <button style={s.btnVue(vue==='semaine')} onClick={() => setVue('semaine')}>Semaine</button>
            <button style={s.btnAdd} onClick={() => { setForm({ type:'rdv' }); setShowModal(true); }}>+ Événement</button>
          </div>
        </div>

        <div style={s.grille}>
          {JOURS.map(j => <div key={j} style={s.jourHeader}>{j}</div>)}
          {jours.map(({ date, estMois }, i) => {
            const estAujourdhui = date.toDateString() === aujourdhui.toDateString();
            const events = eventsJour(date);
            return (
              <div key={i} style={s.jour(estMois, estAujourdhui)} onClick={() => ouvrirModal(date)}>
                <div style={s.jourNum(estAujourdhui)}>{date.getDate()}</div>
                {events.slice(0,3).map((e,j) => (
                  <div key={j} style={s.event(e.couleur)} onClick={(ev) => { ev.stopPropagation(); setEvenementDetail(e); }}>
                    {e.titre}
                  </div>
                ))}
                {events.length > 3 && <div style={{fontSize:'11px', color:'#6B7280'}}>+{events.length-3} autres</div>}
              </div>
            );
          })}
        </div>
      </div>

      <div style={{marginTop:'16px', display:'flex', gap:'12px', flexWrap:'wrap'}}>
        {TYPES.map(t => (
          <div key={t.value} style={{display:'flex', alignItems:'center', gap:'6px', fontSize:'13px', color:'#374151'}}>
            <div style={{width:'12px', height:'12px', borderRadius:'3px', background:t.color}}></div>
            {t.label}
          </div>
        ))}
      </div>

      {evenementDetail && (
        <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}
          onClick={() => setEvenementDetail(null)}>
          <div style={{ background:'white', borderRadius:'10px', padding:'24px', width:'380px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}
            onClick={e => e.stopPropagation()}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'16px'}}>
              <div>
                <div style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px'}}>
                  <div style={{width:'12px', height:'12px', borderRadius:'3px', background:evenementDetail.couleur, flexShrink:0}}></div>
                  <span style={{fontSize:'11px', color:'#6B7280', textTransform:'uppercase', fontWeight:'600'}}>{evenementDetail.type}</span>
                </div>
                <h3 style={{margin:0, color:COLORS.bleu, fontSize:'17px'}}>{evenementDetail.titre}</h3>
              </div>
              <button onClick={() => setEvenementDetail(null)} style={{background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#9CA3AF'}}>✕</button>
            </div>

            <div style={{fontSize:'13px', color:'#374151', marginBottom:'8px'}}>
              📅 {new Date(evenementDetail.date_debut).toLocaleDateString('fr-FR', { weekday:'long', day:'numeric', month:'long', year:'numeric' })}
              {' '}à {new Date(evenementDetail.date_debut).toLocaleTimeString('fr-FR', { hour:'2-digit', minute:'2-digit' })}
            </div>
            {evenementDetail.date_fin && (
              <div style={{fontSize:'13px', color:'#6B7280', marginBottom:'8px'}}>
                Fin : {new Date(evenementDetail.date_fin).toLocaleTimeString('fr-FR', { hour:'2-digit', minute:'2-digit' })}
              </div>
            )}
            {evenementDetail.description && (
              <div style={{fontSize:'13px', color:'#6B7280', marginBottom:'12px', fontStyle:'italic'}}>{evenementDetail.description}</div>
            )}
            {evenementDetail.affaire_id && (() => {
              const affaire = affaires.find(a => a.id === evenementDetail.affaire_id);
              return affaire ? (
                <div style={{background:'#F0F9FF', border:'1px solid #BAE6FD', borderRadius:'6px', padding:'10px 12px', marginBottom:'12px', fontSize:'13px'}}>
                  🔨 Affaire liée : <strong>{affaire.reference}</strong> — {affaire.titre}
                </div>
              ) : null;
            })()}
            {evenementDetail.client_id && (() => {
              const client = clients.find(c => c.id === evenementDetail.client_id);
              return client ? (
                <div style={{background:'#F9FAFB', border:'1px solid #E5E7EB', borderRadius:'6px', padding:'10px 12px', marginBottom:'12px', fontSize:'13px'}}>
                  👤 Client : <strong>{client.nom} {client.prenom||''}</strong>
                </div>
              ) : null;
            })()}

            <div style={{display:'flex', gap:'8px', marginTop:'16px', flexWrap:'wrap'}}>
              {evenementDetail.affaire_id && onOuvrirAffaire && (
                <button
                  style={{flex:1, background:COLORS.bleu, color:'white', border:'none', padding:'10px', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600'}}
                  onClick={() => { onOuvrirAffaire(evenementDetail.affaire_id); setEvenementDetail(null); }}>
                  🔨 Ouvrir l'affaire →
                </button>
              )}
              <button
                style={{background:'#E0F2FE', color:'#0369A1', border:'none', padding:'10px 14px', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600'}}
                onClick={() => ouvrirEdition(evenementDetail)}>
                ✏️ Modifier
              </button>
              <button
                style={{background:'#FEE2E2', color:'#DC2626', border:'none', padding:'10px 14px', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600'}}
                onClick={() => { if(window.confirm(`Supprimer "${evenementDetail.titre}" ?`)) { onSupprimer(evenementDetail.id); setEvenementDetail(null); } }}>
                🗑️
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'white', borderRadius:'8px', padding:'24px', width:'480px', maxHeight:'85vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
              <h3 style={{color:COLORS.bleu, margin:0}}>{modeEdition ? '✏️ Modifier l\'événement' : '➕ Nouvel événement'}</h3>
              <button onClick={() => { setShowModal(false); setModeEdition(false); setForm({}); }} style={{background:'none', border:'none', fontSize:'20px', cursor:'pointer'}}>✕</button>
            </div>

            <label style={s.label}>Type</label>
            <select style={s.input} value={form.type||'rdv'} onChange={e => setForm({...form, type:e.target.value})}>
              {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>

            <label style={s.label}>Titre *</label>
            <input style={s.input} value={form.titre||''} onChange={e => setForm({...form, titre:e.target.value})} placeholder="Ex: Visite chantier Dupont" />

            <label style={s.label}>Date et heure début *</label>
            <input style={s.input} type="datetime-local" value={form.date_debut||''}
              onChange={e => {
                const newDebut = e.target.value;
                const updates = { date_debut: newDebut };
                if (form.date_fin && form.date_fin <= newDebut) updates.date_fin = '';
                setForm({...form, ...updates});
              }} />

            <label style={s.label}>Date et heure fin</label>
            <input style={s.input} type="datetime-local" value={form.date_fin||''}
              min={form.date_debut||''}
              onChange={e => setForm({...form, date_fin:e.target.value})} />

            <label style={s.label}>Client lié</label>
            <select style={s.input} value={form.client_id||''} onChange={e => setForm({...form, client_id:e.target.value, affaire_id:''})}>
              <option value=''>-- Aucun --</option>
              {clients.map(c => <option key={c.id} value={c.id}>{c.nom} {c.prenom||''}</option>)}
            </select>

            <label style={s.label}>Affaire liée{form.client_id ? ` (client sélectionné)` : ''}</label>
            <select style={s.input} value={form.affaire_id||''} onChange={e => setForm({...form, affaire_id:e.target.value})}>
              <option value=''>-- Aucune --</option>
              {(form.client_id
                ? affaires.filter(a => a.client_id === parseInt(form.client_id))
                : affaires
              ).map(a => <option key={a.id} value={a.id}>{a.reference} — {a.titre}</option>)}
            </select>
            {form.client_id && affaires.filter(a => a.client_id === parseInt(form.client_id)).length === 0 && (
              <div style={{fontSize:'12px', color:'#9CA3AF', marginTop:'-6px', marginBottom:'10px'}}>Aucune affaire pour ce client</div>
            )}

            <label style={s.label}>Description</label>
            <input style={s.input} value={form.description||''} onChange={e => setForm({...form, description:e.target.value})} placeholder="Notes optionnelles" />

            <button style={s.btn(COLORS.modules[form.type]||COLORS.bleu)} onClick={validerModal}>
              {modeEdition ? '✅ Enregistrer les modifications' : '✅ Créer l\'événement'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
